<template>
  <div v-if="rate_documents">
    <div class="w-full m-auto m-y-4">
      <div class="bg-white">
        <div class="max-w-screen-xl mx-auto py-5 ">
          <p class="
                text-center text-base
                leading-6
                font-semibold
                uppercase
                text-gray-600
                tracking-wider
              ">
            Current Documents
          </p>
          <div v-if='defaultDocuments' class="
                mt-6
                grid grid-cols-1
                sm:grid-cols-2
                gap-4
                md:grid-cols-2
                lg:mt-8
              ">
            <div v-for="documents in defaultDocuments.files">
              <div
                class="w-full bg-gray-50 hover:bg-gray-200 border border-gray-200 shadow-sm rounded-md col-span-1 py-8 px-8">
                <a :href="'/downloadWeb/' + documents.file_path" target="_blank" class="no-underline">
                  <div class="flex flex-wrap text-center">
                    <i class="far fa-file-pdf text-6xl mb-4 text-teal-500 w-full"></i>
                    <p class=" capitalize m-0 mt-2 text-xl font-semibold text-teal-500 w-full text-center ">
                      {{ documents.name }}
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full m-auto my-4 mt-12 bg-teal-600 p-6 rounded-md">
      <h2 class="text-xl m-2 font-bold text-white">Policy Document Archive</h2>
      <p class="text-lg m-2 text-white">
        If you have a existing cycle insurance policy with us that was
        purchased before <span class="font-semibold">01/01/2025</span>, please select the applicable date below
        corresponding to the date you purchased the policy in order to access
        your policy documents.
      </p>
      <div class="policy-selection">
        <div class="flex flex-col my-4 m-auto">
          <span class="m-2 font-bold text-white text-lg">When did you purchase your policy?</span>

          <tw-select additional-class="" :val="selectedOption" @updated="inputChange" :items="historicDocuments">
          </tw-select>
        </div>

        <div class="my-5 grid grid-cols-1 gap-2 xl:grid-cols-2" v-if="selectedDocuments">
          <div class="flex flex-row w-full m-auto" v-for="documents in selectedDocuments.files">
            <div class="flex w-full flex-row">
              <a :href="'/downloadWeb/' + documents.file_path" target="_blank" class="bg-teal-400 no-underline w-full hover:bg-teal-500 col-span-1 py-4 px-6 rounded-md
                  ">
                <div class="flex flex-wrap text-center">
                  <p class=" capitalize m-0 my-2 text-lg font-semibold text-white w-full text-center">
                    {{ documents.name }}
                    <i class="fas fa-download float-right text-lg text-white"></i>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  computed: {
    historicDocuments() {
      return this.rate_documents.filter((v, i) => i > 0);
    }
  },
  data() {
    return {
      rate_documents: [
        {
          name: '01/01/2025 onwards',
          value: '2025',
          files: [
            {
              name: 'Poicy Document',
              file_path: '2025/Policy_Document.pdf'
            },
            {
              name: 'IPID',
              file_path: '2025/IPID.pdf'
            }
          ]
        },
        {
          name: 'Between 20/12/2023 and 31/12/2024',
          value: '12-2023',
          files: [
            {
              name: 'Policy Document',
              file_path: '12-2023/Policy_Document.pdf'
            },
            {
              name: 'IPID',
              file_path: '12-2023/IPID.pdf'
            }
          ]
        },
        {
          name: 'Between 01/03/2021 and 20/12/2023',
          value: '2023',
          files: [
            {
              name: 'Policy Document',
              file_path: '2023/Policy_Document.pdf'
            },
            {
              name: 'IPID',
              file_path: '2023/IPID.pdf'
            }
          ]
        }
      ],
      selectedIndex: null,
      selectedDocuments: null,
      selectedOption: null,
      defaultDocuments: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.selectedOption = this.rate_documents[1];
      this.defaultDocuments = this.rate_documents[0];
      this.selectedDocuments = this.rate_documents[1];
    },
    inputChange(e) {
      this.selectedIndex = e.value;
      this.selectedDocuments = this.rate_documents.find(item => item.value == this.selectedIndex);
      this.selectedOption = e;
    },
  },
};
</script>
  